import Vue from 'vue'

Vue.filter('time', function(value) {
	let d = new Date(parseInt(value));
	return (d.getFullYear()) + '-' + (d.getMonth() + 1 > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '-' + (d.getDate() >
		9 ? d.getDate() : '0' + d.getDate())
});
Vue.filter('allTime', function(value) {
	let d = new Date(parseInt(value));
	return (d.getFullYear()) + '-' + (d.getMonth() + 1 > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '-' + (d.getDate() >
		9 ? d.getDate() : '0' + d.getDate()) + '  ' + (d.getHours() > 9 ? d.getHours() : '0' + d.getHours()) + ':' + (d.getMinutes() >
		9 ? d.getMinutes() : '0' + d.getMinutes()) + ':' + (d.getSeconds() > 9 ? d.getSeconds() : '0' + d.getSeconds())
});

Vue.filter('sex', function(value) {
	if (value == 1) {
		return "男"
	} else if (value == 2) {
		return "女"
	}
});

Vue.filter('single', function(value) {
	if (value.toString().length <= 1) {
		return "0" + value
	} else {
		return value
	}
});

Vue.filter('null', function(value) {
	if (!value) {
		return "-"
	} else {
		return value
	}
});

Vue.prototype.getCharFromUtf8 = function(strUtf8) {
	var bstr = "";
	var nOffset = 0; //   processing   point   on   strUtf8 

	if (strUtf8 == "")
		return "";

	strUtf8 = strUtf8.toLowerCase();
	nOffset = strUtf8.indexOf("%e");
	if (nOffset == -1)
		return strUtf8;

	while (nOffset != -1) {
		bstr += strUtf8.substr(0, nOffset);
		strUtf8 = strUtf8.substr(nOffset, strUtf8.length - nOffset);
		if (strUtf8 == "" || strUtf8.length < 9) //   bad   string 
			return bstr;

		bstr += this.utf8CodeToChineseChar(strUtf8.substr(0, 9));
		strUtf8 = strUtf8.substr(9, strUtf8.length - 9);
		nOffset = strUtf8.indexOf("%e");
	}

	return bstr + strUtf8;
};

Vue.prototype.utf8CodeToChineseChar = function(strUtf8) {
	var iCode, iCode1, iCode2;
	iCode = parseInt("0x" + strUtf8.substr(1, 2));
	iCode1 = parseInt("0x" + strUtf8.substr(4, 2));
	iCode2 = parseInt("0x" + strUtf8.substr(7, 2));
	return String.fromCharCode(((iCode & 0x0F) << 12) | ((iCode1 & 0x3F) << 6) | (iCode2 & 0x3F));
}

Date.prototype.Format = function(fmt) {
	var o = {
		"M+": this.getMonth() + 1, //月份 
		"d+": this.getDate(), //日 
		"H+": this.getHours(), //小时 
		"m+": this.getMinutes(), //分 
		"s+": this.getSeconds(), //秒 
		"q+": Math.floor((this.getMonth() + 3) / 3), //季度 
		"S": this.getMilliseconds() //毫秒 
	};
	if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[
			k]).substr(("" + o[k]).length)));
	return fmt;
}

Vue.directive('clickoutside', {
	bind(el, binding) {
		function handler(e) {
			if (el.contains(e.target) || e.target.className.includes(binding.arg)) {
				return false;
			}
			if (binding.expression) {
				binding.value(e);
			}
		}
		el._zClickOutside = handler;
		document.addEventListener('click', handler);
	},
	unbind(el) {
		// 解除事件监听
		document.removeEventListener('click', el._zClickOutside);
		delete el._zClickOutside;
	}
})
